import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'difficultyLevel'
})
export class DifficultyLevelPipe implements PipeTransform {
    transform(value: string): string {
        if (!value) return '';

        const levelMap: { [key: string]: string } = {
            'LOW': 'Easy',
            'EASY': 'Easy',
            'MEDIUM': 'Medium',
            'HIGH': 'Hard',
            'HARD': 'Hard'
        };

        const upperValue = value.toUpperCase();
        return levelMap[upperValue] || value;
    }
}
